import { captureException, setContext } from '@sentry/browser';
import jQuery from 'jquery';

function Portlet(uid, options) {
  this.options = jQuery.extend({
    gridPosition: [
      [1, 1],
      [2, 2],
    ],
  }, options);
  this.uid = uid;
  this.view = this.options.view;
  this.gridPosition = this.options.gridPosition;
  this.isPersistent = this.options.isPersistent;
}

Portlet.prototype.getGridPosition = function getGridPosition() {
  return this.gridPosition;
};

Portlet.prototype.updateGridPosition = function updateGridPosition() {
  const elPortlet = jQuery(`#${this.uid}`).parent().parent().parent();
  const posNew = elPortlet.position();
  const positionLeft = Math.round(posNew.left);
  const positionTop = Math.round(posNew.top);
  const columnWidth = VCOM.Portal.getColumnWidth();
  const rowHeight = VCOM.Portal.getRowHeight();
  const posx1 = positionLeft / columnWidth;
  const posy1 = positionTop / rowHeight;
  const posx2 = (positionLeft + Math.round(elPortlet.width())) / columnWidth;
  const posy2 = (positionTop + Math.round(elPortlet.height())) / rowHeight;

  const positions = [posx1, posx2, posy1, posy2];
  const hasNonInteger = positions.some((value) => Number.isInteger(value) === false);
  if (hasNonInteger) {
    captureException(new Error(`Invalid positions: ${positions.join(', ')}`));
    setContext('calculation', {
      columnWidth,
      rowHeight,
      positionLeft,
      positionTop,
      elPortletWidth: Math.round(elPortlet.width()),
      elPortletHeight: Math.round(elPortlet.height()),
    });
  }

  this.gridPosition = [
    [posx1, posy1],
    [posx2, posy2],
  ];
};

export default Portlet;
